/**
 * Brand and SEO configuration constants.
 *
 * `siteConfig` provides core brand values consumed throughout the app (emails,
 * page titles, Stripe portal headline). `seoConfig` provides the default
 * OpenGraph / Twitter meta tags applied to every page via `root.tsx`.
 *
 * @see {@link file://app/lib/server/seo/seo-helpers.ts} — `getDefaultSeoTags()` consumes `seoConfig`
 * @see {@link file://app/root.tsx} — injects default meta from this config
 */
import type { DefaultSeoProps } from "../server/seo/types"

export const siteConfig = {
  title: "BudgetBot.App",
  description:
    "Integrate your financial accounts and manage your finances with ease using BudgetBot.App's AI-powered supercharged spreadsheet interface and intelligent AI assistant.",
  baseUrl: "https://budgetbot.app",
  ogImage: "https://budgetbot.app/og-image.png",
} as const

export const seoConfig: DefaultSeoProps = {
  title: siteConfig.title,
  description: siteConfig.description,
  openGraph: {
    type: "website",
    locale: "en_US",
    title: siteConfig.title,
    description: siteConfig.description,
    siteName: siteConfig.title,
    images: [
      {
        url: siteConfig.ogImage,
        // The shape link previews use (1.91:1). A wider image is cropped.
        width: 1200,
        height: 630,
        alt: siteConfig.title,
      },
    ],
  },
  twitter: {
    handle: "@BudgetBotApp",
    // An @handle, never a URL: X reads `twitter:site` as the account the
    // card belongs to.
    site: "@BudgetBotApp",
    cardType: "summary_large_image",
  },
}
